import Vue from 'vue'
// import $store from '@/store'

const API_BASE_URL = process.env.API_BASE_URL + '/v1/newsletter_recipients'

export default {
  storeRecipient(params) {
    return Vue.http.post(API_BASE_URL, params
    )
  },
}



// WEBPACK FOOTER //
// ./src/services/newsletter_reciepients.js